import styles from "./MembershipPlans.module.css"

function MembershipPlans() {
  const plans = [
    {
      id: "essentials",
      name: "Essentials",
      price: 89,
      period: "month",
      features: ["1 item at a time", "3 swaps per month", "Access to essentials collection", "Free shipping & returns"],
      buttonText: "Get Started",
      isPopular: false,
    },
    {
      id: "luxe",
      name: "Luxe",
      price: 159,
      period: "month",
      features: [
        "Perfect for fashion enthusiasts who want more variety",
        "2 items at a time",
        "4 swaps per month",
        "Access to 10+ designer collections",
        "10% off purchase options",
      ],
      buttonText: "Get Started",
      isPopular: true,
    },
    {
      id: "couture",
      name: "Couture",
      price: 249,
      period: "month",
      features: [
        "4 items at a time",
        "Unlimited swaps",
        "Access to exclusive brands",
        "Priority shipping",
        "Personal stylist consultation",
        "20% off purchase options",
      ],
      buttonText: "Get Started",
      isPopular: false,
    },
  ]

  return (
    <section className={styles.membershipPlans}>
      <h2 className={styles.sectionTitle}>Membership Plans</h2>
      <p className={styles.sectionSubtitle}>
        Choose the perfect plan for your style needs. All plans include free shipping, returns, and dry cleaning.
      </p>

      <div className={styles.plansContainer}>
        {plans.map((plan) => (
          <div key={plan.id} className={`${styles.planCard} ${plan.isPopular ? styles.popularPlan : ""}`}>
            {plan.isPopular && <div className={styles.popularBadge}>Popular</div>}
            <h3 className={styles.planName}>{plan.name}</h3>
            <div className={styles.planPrice}>
              <span className={styles.price}>${plan.price}</span>
              <span className={styles.period}>/{plan.period}</span>
            </div>

            <ul className={styles.planFeatures}>
              {plan.features.map((feature, index) => (
                <li key={index} className={styles.feature}>
                  <svg className={styles.checkIcon} viewBox="0 0 24 24" width="16" height="16">
                    <polyline points="20 6 9 17 4 12" fill="none" stroke="currentColor" strokeWidth="2" />
                  </svg>
                  {feature}
                </li>
              ))}
            </ul>

            <button className={styles.planButton}>{plan.buttonText}</button>
          </div>
        ))}
      </div>
    </section>
  )
}

export default MembershipPlans
